// extracted by mini-css-extract-plugin
export var aboutUs = "styles-module--aboutUs--c6596";